import React from 'react';
import PropTypes from 'prop-types';

const renderIcon = (active, selected, valid, index) => {
  if (selected) {
    return <i className="fa fa-dot-circle" />;
  } if (active && valid) {
    return <i className="fa fa-check-circle" />;
  } if (active && !valid) {
    return <i className="fa fa-exclamation-circle" />;
  }
  return <span className="badge">{index + 1}</span>;
};

function TitleTabBar({
  style, title, tabs, toggleTab, selectedTab, activeTab, errors, tabTitles,
}) {
  return (
    <div
      className="sticky-title"
      style={{
        ...style,
        top: 52,
        width: style.width + 30 || null,
      }}
    >
      <h2 className="demibold">{`${title} - ${tabTitles[selectedTab]}`}</h2>
      <span className="body-text-3">
        <i className="fa fa-info-circle" />
        &nbsp;All questions are required unless otherwise specified
      </span>

      <div className="d-flex gap-1 tabs mt-4">
        {
          tabs.map((tab, index) => (
            <div className="col" key={tab}>
              <div
                className={`tab ${
                  activeTab !== null && index <= activeTab ? 'active ' : ''
                } ${index === selectedTab ? 'selected' : ''
                } ${errors[`${tab}_errors_count`.toLowerCase()] > 0 ? 'invalid' : ''
                }`}
                id={`create-proposal-tab-${index}`}
              >
                {renderIcon(
                  (activeTab != null && index <= activeTab),
                  index === selectedTab,
                  !errors[`${tab}_errors_count`.toLowerCase()] > 0,
                  index,
                )}
                <a
                  href="tab"
                  className="body-text-3 medium"
                  key={tab}
                  onClick={(e) => toggleTab(e, index)}
                >
                  { tab }
                </a>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

TitleTabBar.defaultProps = {
  style: {},
  title: '',
  errors: {},
  activeTab: null,
};

TitleTabBar.propTypes = {
  style: PropTypes.shape({}),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  tabTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.number.isRequired,
  errors: PropTypes.shape({}),
  activeTab: PropTypes.number,
};

export default TitleTabBar;
